import { styled } from "@linaria/react"
import { observer } from "mobx-react-lite"

import { Button } from "@/components/Button/Button.tsx"
import { Horizontal, Vertical } from "@/components/Flex.ts"
import { LLMLogChat } from "@/components/LLMLogChat/LLMLogChat.tsx"
import { useOrgContext } from "@/hooks/useRootContext.ts"
import { RelevantFiles } from "@/routes/tasks/RelevantFiles.tsx"
import { TaskSettingsJsonDialog } from "@/routes/tasks/TaskViewScene/TaskSettingsJsonDialog.tsx"
import * as textStyles from "@/styles/textStyles.ts"

import type { ScrollableModel } from "@/components/Scrollable/ScrollableModel.ts"
import type { TaskViewModel } from "@/routes/tasks/TaskViewScene/TaskViewModel.ts"

export const TaskDevTab = observer((props: {
  model: TaskViewModel
  scrollableModel: ScrollableModel
}) => {
  const task = props.model.task.get()
  const relevantFiles = task?.relevantFiles || []
  const context = useOrgContext()

  return (
    <Vertical alignItems="flex-start" gap="12px">
      <Horizontal gap="12px">
        {relevantFiles.length > 0 && (
          <Vertical gap="4px">
            <RelevantFilesTitle>Relevant files</RelevantFilesTitle>
            <RelevantFilesSection>
              <RelevantFiles files={relevantFiles} />
            </RelevantFilesSection>
          </Vertical>
        )}

        {task?.initRuntimeConfigState && (
          <Button onClick={() => context.queries.apiClient.resetProjectCreationFlow(task.id, "Preview")}>
            Reset scripts
          </Button>
        )}

        {task?.id && <TaskSettingsJsonDialog taskId={task.id} />}
      </Horizontal>
      <LLMLogChat {...props} />
    </Vertical>
  )
})

const RelevantFilesTitle = styled.div`
  color: var(--text-color-40);

  ${textStyles.smallestFontSize};
`

const RelevantFilesSection = styled(Horizontal)`
  ${textStyles.smallFontSize};

  gap: 4px;
  flex-wrap: wrap;

  color: var(--text-color-60);
`
